import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Box, Icon } from "../../../common/components";
import { palette, spacing } from "../../../styles/theme";
import { ProductLineType } from "../../../types";
import {
  ProductLinesToColor,
  ProductLinesToIcon,
} from "../../../constant/common.constant";

interface Props {
  line: ProductLineType;
  showDescription?: boolean;
}
const ProductLine = ({ line, showDescription }: Props) => {
  const { t } = useTranslation();
  return (
    <Box
      display={"flex"}
      p={showDescription ? "6px 12px 6px 10px" : "6px"}
      sx={{
        border: `1px solid ${palette.grey.midGrey}`,
        borderRadius: "12px",
      }}
      alignItems={"center"}
      gap={{ xs: spacing.xsMobile, lg: spacing.xsDesktop }}
    >
      <Icon
        icon={ProductLinesToIcon[line]}
        color={ProductLinesToColor[line]}
        size={12}
      />
      {showDescription && (
        <Typography variant="textXs" color={ProductLinesToColor[line]}>
          {t(`line.${line}.title`)}
        </Typography>
      )}
    </Box>
  );
};

export default ProductLine;
